var path = 'areas/tasks/views/task-status.html';
var html = "<span class=status uib-popover={{vm.tip}} popover-title={{vm.title}} popover-trigger=mouseenter popover-placement={{vm.popDirection}} popover-class=task-status ng-class=\"[vm.stateClass,  {'status-previous': vm.previous, 'status-archive': vm.archive}]\"> <i class=fa ng-class=\"[vm.icon, {'fa-spin': vm.isSpinning }]\"></i> <span class=status-overlay ng-if=vm.isAlert><i class=\"fa fa-exclamation-triangle\"></i></span> </span> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/tasks/views/task-status.html
// module id = 988
// module chunks = 1